import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from '@material-ui/core/styles';
import { ThemeContext } from '../ThemeProvider';
export const ThemeSelector = ({ color, children }) => {
    // If color isn't provided, render children without selecting a theme.
    // This allows components to inherit the parent theme when not set.
    if (!color)
        return _jsx(_Fragment, { children: children });
    return (_jsx(ThemeContext.Consumer, { children: (themeContext) => {
            if (!themeContext)
                return;
            return (_jsx(ThemeProvider, Object.assign({ theme: themeContext.theme[color] }, { children: children })));
        } }));
};
export default ThemeSelector;
//# sourceMappingURL=ThemeSelector.js.map